var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50008 7.9165H28.5001C31.9979 7.9165 34.8334 10.752 34.8334 14.2498V23.7498C34.8334 27.2476 31.9979 30.0832 28.5001 30.0832H9.50008C6.00228 30.0832 3.16675 27.2476 3.16675 23.7498V14.2498C3.16675 10.752 6.00228 7.9165 9.50008 7.9165ZM8.32841 23.354H29.6717C30.3276 23.354 30.8592 22.8223 30.8592 22.1665C30.8592 21.5107 30.3276 20.979 29.6717 20.979H8.32841C7.67257 20.979 7.14091 21.5107 7.14091 22.1665C7.14091 22.8223 7.67257 23.354 8.32841 23.354Z",
    fill: "#1B9075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnings);
export default __webpack_public_path__ + "static/media/earnings.f0fae5e77adb118b8ccdbef4bac4c449.svg";
export { ForwardRef as ReactComponent };